/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$context-menu-box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !default;
$context-menu-border-radius: 3px !default;
$context-menu-normal-padding: 12px !default;
$context-menu-max-width: 270px !default;
$context-menu-inset-box-shadow: inset 0px -1px 0px #e5e5e5 !default;
$context-menu-max-icon-height: 32px !default;
$context-menu-max-icon-width: 32px !default;
$context-menu-font-size: 18px !default;
$context-menu-border-color: transparent !default;
$context-menu-border-width: 0px !default;
$context-menu-border-style: none !default;
$context-menu-divider-border-color: transparent !default;
$context-menu-divider-border-width: 0px !default;
$context-menu-divider-border-style: none !default;
/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  font-family: $font-family-base;
  z-index: 100;
  margin: 0 !important; // For proper positioning of Menu on component which fired the click event, "important!" is necessary
  padding: 0 !important;

  * {
    box-sizing: border-box;
    outline: none;
  }
}

:host(.#{$prefix}position-left) {
  left: 0;
  right: unset;
}

:host(.#{$prefix}position-right) {
  left: unset;
  right: 0;
}

.#{$prefix}context-menu-container {
  display: inline-block;
  position: absolute;
  top: -2px;
  width: $context-menu-max-width;
  box-shadow: $context-menu-box-shadow;
  border-radius: $context-menu-border-radius;
  border: $context-menu-border-width $context-menu-border-style $context-menu-border-color;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s cubic-bezier(0.33, 0, 0.35, 1) 0.5s, visibility 0.25s cubic-bezier(0.33, 0, 0.35, 1) 0.5s,
    transform 0.25s ease-in-out 0.5s;

  &.#{$prefix}visible {
    overflow: hidden;
    opacity: 1;
    visibility: visible;
    transition: opacity 0.25s cubic-bezier(0.33, 0, 0.35, 1) 0s, visibility 0.25s cubic-bezier(0.33, 0, 0.35, 1) 0s,
      transform 0.25s ease-in-out 0s;
  }

  &.#{$prefix}position-left {
    transform: translate3d(var(--offsetLeft), var(--offsetTop), 0px);
    left: 0;
  }

  &.#{$prefix}position-right {
    transform: translate3d(calc(var(--offsetLeft) * -1), var(--offsetTop), 0px);
    right: -2px;
  }

  .#{$prefix}context-menu-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: v(backgroundColor);
    overflow: hidden;
    border-radius: $context-menu-border-radius;

    .#{$prefix}context-menu-title {
      display: flex;
      align-items: center;
      width: 100%;
      padding: $context-menu-normal-padding;
      height: 48px;
      box-shadow: $context-menu-inset-box-shadow;
      background-color: v(menuTitleBackgroundColor);

      .#{$prefix}context-menu-label {
        width: 100%;
        cursor: initial;
      }

      .#{$prefix}context-menu-label {
        font-weight: normal;
        font-size: 18px;
        line-height: 24px;
        color: v(labelColor);
        @include noneUserSelect();
      }

      .#{$prefix}context-menu-icon {
        fill: v(iconColor);
        width: auto;
      }

      &.#{$prefix}icon-with-label {
        &.#{$prefix}icon-right {
          flex-direction: row-reverse;
          justify-content: flex-start;

          .#{$prefix}context-menu-label {
            justify-content: flex-end;
            text-align: right;
            padding-left: 10px;
          }

          .#{$prefix}context-menu-icon {
            justify-content: flex-end;
          }
        }

        &.#{$prefix}icon-left {
          flex-direction: row-reverse;
          justify-content: flex-end;

          .#{$prefix}context-menu-label {
            justify-content: flex-start;
            text-align: left;
          }

          .#{$prefix}context-menu-icon {
            justify-content: flex-start;
            padding-right: 10px;
          }
        }

        .#{$prefix}context-menu-label,
        .#{$prefix}context-menu-icon {
          width: auto;
        }
      }

      &.#{$prefix}icon-right {
        flex-direction: row;

        .#{$prefix}context-menu-label {
          justify-content: flex-start;
          text-align: left;
        }

        .#{$prefix}context-menu-icon {
          justify-content: flex-end;
        }

        &:not(.#{$prefix}icon-with-label) {
          margin-left: -2px;
        }
      }

      &.#{$prefix}icon-left {
        flex-direction: row-reverse;

        .#{$prefix}context-menu-label {
          justify-content: flex-end;
          text-align: left;
        }

        .#{$prefix}context-menu-icon {
          justify-content: flex-start;
          padding-right: $context-menu-normal-padding;
        }
      }
    }
  }

  &.#{$prefix}small {
    .#{$prefix}context-menu-title {
      height: 33px;
      padding: 10px;

      .#{$prefix}context-menu-label {
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
      }
    }
  }

  &.#{$prefix}touch-device {
    width: #{$context-menu-max-icon-width};
    height: #{$context-menu-max-icon-height};
    opacity: 0 !important;

    &.#{$prefix}visible {
      opacity: 0 !important;

      select {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 100;
        font-size: $context-menu-font-size;
      }
    }

    select {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 100;
      font-size: $context-menu-font-size;
    }

    &.#{$prefix}small {
      select {
        font-size: 16px;
      }
    }
  }

  .#{$prefix}divider-wrapper {
    position: absolute;
    padding: 0px 12px;
    top: 48px;
    width: 100%;

    .#{$prefix}divider {
      border: $context-menu-divider-border-width $context-menu-divider-border-style $context-menu-divider-border-color;
    }
  }

  &.#{$prefix}small {
    .#{$prefix}divider-wrapper {
      top: 33px;
    }
  }
}
